import React from 'react';
import { Button } from '../ui/button';
import { AlertTriangle, LogOut, X } from 'lucide-react';

export default function LogoutConfirmDialog({
  open,
  onOpenChange,
  operacoesCongeladas = [],
  producaoAtiva,
  onLogout,
  onVerCongeladas,
}) {
  if (!open) return null;

  const congeladasPendentes = operacoesCongeladas.filter(
    (c) => !(producaoAtiva && producaoAtiva.registo?.id === c.registo_id)
  );

  return (
    <div className="fixed inset-0 z-[60] flex flex-col" style={{ background: '#F8FAFC' }}>
      {/* Header */}
      <div
        className="flex items-center justify-between px-5 py-4"
        style={{ background: '#0B3B30' }}
      >
        <h1 className="text-lg font-bold text-white flex items-center gap-2">
          <LogOut className="h-5 w-5" />
          Confirmar Saída
        </h1>
        <button
          onClick={() => onOpenChange(false)}
          className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{ background: 'rgba(255,255,255,0.1)' }}
          data-testid="btn-fechar-logout"
        >
          <X className="h-5 w-5 text-white" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-sm space-y-6">
          <div className="text-center">
            <div
              className="w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center"
              style={{ background: '#FEE2E2' }}
            >
              <LogOut className="h-10 w-10" style={{ color: '#DC2626' }} />
            </div>
            <p className="text-lg font-semibold text-stone-800">
              Tens a certeza que queres sair?
            </p>
            <p className="text-sm text-stone-500 mt-1">
              Vais terminar a tua sessão neste dispositivo.
            </p>
          </div>

          {/* Aviso de operações congeladas */}
          {congeladasPendentes.length > 0 && (
            <div className="p-4 bg-amber-50 border border-amber-200 rounded-2xl">
              <div className="flex items-start gap-3">
                <AlertTriangle className="h-6 w-6 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-amber-800">
                    Tens {congeladasPendentes.length} operaç{congeladasPendentes.length !== 1 ? 'ões congeladas' : 'ão congelada'}
                  </p>
                  <ul className="mt-1 space-y-0.5">
                    {congeladasPendentes.slice(0, 3).map((c, i) => (
                      <li key={i} className="text-xs text-amber-700">
                        {c.operacao_codigo} – {c.operacao_nome} ({c.lote_codigo || 'Lote ?'})
                      </li>
                    ))}
                  </ul>
                  <button
                    className="mt-2 text-xs text-amber-600 underline font-medium"
                    onClick={() => {
                      onOpenChange(false);
                      onVerCongeladas && onVerCongeladas();
                    }}
                  >
                    Ver operações congeladas
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Botões */}
          <div className="flex flex-col gap-3">
            <Button
              className="w-full h-14 rounded-2xl text-base font-bold"
              style={{ background: '#DC2626', color: '#FFFFFF' }}
              onClick={() => {
                onOpenChange(false);
                onLogout && onLogout();
              }}
              data-testid="btn-confirmar-sair"
            >
              <LogOut className="h-5 w-5 mr-2" />
              Sair
            </Button>
            <Button
              variant="outline"
              className="w-full h-14 rounded-2xl text-base font-bold border-stone-300"
              onClick={() => onOpenChange(false)}
              data-testid="btn-cancelar-sair"
            >
              Cancelar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
